import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as Network from '../../../../../../../helpers/networkHelpers';
import {changeVisibility} from '../../../actions';
import {addProductToBasket} from '../../../../../../../actions/transactions/basket';
import {getProducts} from '../../../../../../../actions/transactions/purchases';
import {PublishProfileToggle} from './PublishProfileToggle';
import {JoinNetwork} from './JoinNetwork';
import Loader from '../../../../../../common/elements/Loader'
import {PublishWarningError} from '../../../elements/ui';

class PublishedStatus extends Component {
  constructor() {
    super();
    this.state = {
      isOpen: false,
      isWarningModalOpen: false
    }
  }

  componentWillMount() {
    // const {permissions, getProducts} = this.props;
    // if (!permissions.hasExecute) return getProducts();
  }

  render() {
    const {visibility, permissions, changeVisibility, products, addProductToBasket, ui, summary, experience} = this.props,
      {visible} = visibility, {personId} = ui,
      // currentNetwork = Network.setCurrentNetwork(networkId),
      // networkTitle = Network.setNetworkTitle(currentNetwork),
      {isOpen, isWarningModalOpen} = this.state;
    // if (!hasExecute && !products) return <Loader />;
    // const profileProduct = products.filter((product) => product.type.id === 1)[0];
    return (
      <span>

                        <PublishProfileToggle
                          visible={ visible }
                          // networkTitle={ networkTitle }
                          summary={summary}
                          experience={experience}
                          openWarningModal={ () => this.setState({isWarningModalOpen: true}) }
                          handleToggle={ (toggle) => changeVisibility(personId, toggle)}
                        />

        { isWarningModalOpen && <PublishWarningError
          cancelWarningModal={ () => this.setState({isWarningModalOpen: false}) }
        />
        }

                    </span>

      //     : <JoinNetwork
      //     product={ profileProduct }
      //     // networkTitle={ networkTitle }
      //     // network={ currentNetwork }
      //     {...this.props }
      //     addToBasket={ (id) => addProductToBasket(id) }
      //     isOpen={ isOpen }
      //     openModal={ () => this.setState({isOpen: true}) }
      //     cancelModal={ () => this.setState({isOpen: false}) }
      // />
    );
  }
}

const mapStateToProps = state => {
  return {
    products: state.transactions.products
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeVisibility: (personId, toggle) => dispatch(changeVisibility(personId, toggle)),
    getProducts: () => dispatch(getProducts()),
    addProductToBasket: productId => dispatch(addProductToBasket(productId))
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(PublishedStatus);



// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/body/visibility/PublishedStatus.js